module.exports = __webpack_public_path__ + "static/media/pattern.c4113510.png";